<div class="munily-schedule-card" role="group" [attr.aria-label]="data.dayLabel">
  <div class="munily-schedule-card__day-label">{{ data.dayLabel }}</div>

  <div class="munily-schedule-card__slots">
    <ng-container *ngIf="data.slots?.length; else emptySlots">
      <div class="munily-schedule-card__slot" *ngFor="let slot of data.slots">
        <div
          class="munily-schedule-card__indicator"
          [class.munily-schedule-card__indicator--unavailable]="data.isAvailable === false"
          aria-hidden="true"
        ></div>
        <div class="munily-schedule-card__times" [class.munily-schedule-card__times--center]="data.isAvailable === false">
          <span class="munily-schedule-card__time-line">{{ slot.fromLabel }}</span>
          <span *ngIf="slot.toLabel" class="munily-schedule-card__time-line">{{ slot.toLabel }}</span>
        </div>
      </div>
    </ng-container>
    <ng-template #emptySlots>
      <p class="munily-schedule-card__empty">{{ emptyLabel }}</p>
    </ng-template>
  </div>
</div>
